import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
const links = [{
  to: '/',
  label: 'Home'
}, {
  to: '/accommodations',
  label: 'Apartments'
}, {
  to: '/experiences',
  label: 'Experiences'
}, {
  to: '/gallery',
  label: 'Gallery'
}, {
  to: '/about',
  label: 'About & rules'
}, {
  to: '/contact',
  label: 'Contact'
}];
export function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';
  useEffect(() => setOpen(false), [location.pathname]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const solid = scrolled || !isHome || open;
  return <header className={`fixed inset-x-0 top-0 z-50 transition-colors duration-200 ease-premium ${solid ? 'border-b border-forest-700/10 bg-ivory-100/95 backdrop-blur' : 'bg-transparent'}`} data-id="element-232" data-mp="2wmfiio0w9a69">
      <div className="mx-auto flex max-w-[1240px] items-center justify-between px-5 py-3.5 sm:px-8 lg:px-12" data-id="element-233" data-mp="2morch1xu8g8s">
        <Link to="/" aria-label="Bel Air Luxury Apartment — home" data-id="element-234" data-mp="2hpy942c9m5mc">
          <Logo tone={solid ? 'dark' : 'light'} size="sm" data-id="element-235" data-mp="3fasxliy0zse5" />
        </Link>

        <nav className="hidden items-center gap-7 lg:flex" aria-label="Primary" data-id="element-236" data-mp="3adaitbxbuiy8">
          {links.map(link => <NavLink key={link.to} to={link.to} end={link.to === '/'} className={({
          isActive
        }) => `group relative whitespace-nowrap py-1 text-[13px] transition-colors duration-150 ease-premium ${solid ? isActive ? 'text-forest-700' : 'text-muted hover:text-forest-700' : isActive ? 'text-ivory-100' : 'text-ivory-200/85 hover:text-ivory-100'}`} data-id="element-237" data-mp="35jy885phgcoh">
              {({
            isActive
          }) => <>
                  {link.label}
                  <span aria-hidden="true" className={`absolute inset-x-0 -bottom-0.5 h-px origin-left bg-gold-400 transition-transform duration-200 ease-premium ${isActive ? 'scale-x-100' : 'scale-x-0 group-hover:scale-x-100'}`} data-id="element-238" data-mp="1mla1v8orpm4b" />
                </>}
            </NavLink>)}
        </nav>

        <div className="flex items-center gap-2" data-id="element-239" data-mp="13o8vbjfkfdy9">
          <Link to="/booking" className={`hidden whitespace-nowrap rounded-full px-5 py-2.5 text-[13px] transition-colors duration-150 ease-premium sm:inline-flex ${solid ? 'bg-forest-700 text-ivory-100 hover:bg-forest-600' : 'bg-gold-400 text-forest-800 hover:bg-gold-300'}`} data-id="element-240" data-mp="2t2ezrqs4st8j">
            Book a stay
          </Link>
          <button type="button" onClick={() => setOpen(value => !value)} aria-expanded={open} aria-label={open ? 'Close menu' : 'Open menu'} className={`inline-flex h-10 w-10 items-center justify-center rounded-full transition-colors duration-150 ease-premium lg:hidden ${solid ? 'text-forest-700 hover:bg-forest-50' : 'text-ivory-100 hover:bg-ivory-100/15'}`} data-id="element-241" data-mp="w47pye9jvfie">
            {open ? <XIcon size={19} data-id="element-242" data-mp="1f196mwcgv426" /> : <MenuIcon size={19} data-id="element-243" data-mp="1a4906kbpfzaj" />}
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-244" data-mp="1a25zn6cxenrk">
        {open && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="overflow-hidden border-t border-forest-700/10 bg-ivory-100 lg:hidden" data-id="element-245" data-mp="3gtx40p2fixa1">
            <nav className="mx-auto flex max-w-[1240px] flex-col px-5 py-2 sm:px-8" aria-label="Mobile" data-id="element-246" data-mp="27vxcd64mxf48">
              {links.map((link, index) => <motion.div key={link.to} initial={{
            opacity: 0,
            x: -8
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.2,
            delay: index * 0.035,
            ease: [0.23, 1, 0.32, 1]
          }} data-id="element-247" data-mp="2gyq2h622zksh" data-mpi={index}>
                  <NavLink to={link.to} end={link.to === '/'} className={({
              isActive
            }) => `block border-b border-forest-700/10 py-3.5 font-display text-xl ${isActive ? 'text-gold-600' : 'text-forest-700'}`} data-id="element-248" data-mp="1t8vrku1bo6av">
                    {link.label}
                  </NavLink>
                </motion.div>)}
              <Link to="/booking" className="my-4 inline-flex justify-center rounded-full bg-forest-700 px-5 py-3 text-[13px] text-ivory-100" data-id="element-249" data-mp="xxecmh1ahix6">
                Book a stay
              </Link>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}